// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-module--wrapper--2fn8g","narrow":"wrapper-module--narrow--3TSAN","default":"wrapper-module--default--312yb","wide":"wrapper-module--wide--2BujX"};